import NavPanel from './NavPanel';

export default NavPanel;
